module.exports = __webpack_public_path__ + "img/s2-2-ja.2cb38159.jpg";